// import React from "react";
// import Footer from "./Footer";
// import NavBar from "./NavBar";

// const OnePersonCompany = () => {
//   return (
//     <div style={{ fontFamily: "Arial, sans-serif", backgroundColor: "#f5f5f5", margin: 0, padding: 0 }}>
//       <NavBar />
//       {/* Header */}
//       <div
//         style={{
//           backgroundColor: "#00b050",
//           color: "white",
//           padding: "30px",
//           fontSize: "28px",
//           fontWeight: "bold",
//           textAlign: "center",
//           marginTop: '65px'
//         }}
//       >
//         One Person Company Registration
//       </div>
//       <p style={{ width: "1200px", margin: "20px auto", padding: "20px" }}>
//         One Person Company (OPC) Registration is an ideal choice for startups or individuals who wish to operate a business as a single owner. An OPC combines the benefits of a Private Limited Company while restricting the number of shareholders to one.
//       </p>

//       {/* Content */}
//       <div style={{ width: "1200px", marginLeft: '12px', marginTop: "15px", padding: "20px" }}>
//         <div
//           style={{
//             background: "white",
//             padding: "25px",
//             borderRadius: "8px",
//             boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
//             fontFamily: "Arial, sans-serif",
//             lineHeight: "1.6",
//             color: "#333"
//           }}
//         >

//           {/* About One Person Company */}
//           <div>
//             <h2 style={{ color: "#001F3F", fontWeight: 600, marginBottom: "6px", fontFamily: "Times New Roman, Georgia, serif" }}>
//               About One Person Company (OPC)
//             </h2>
//             <div
//               style={{
//                 width: "80px",
//                 height: "3px",
//                 background: "#22c55e",
//                 borderRadius: "2px"
//               }}
//             ></div>
//           </div>

//           <p>
//             A One Person Company (OPC) is a modern business structure introduced to enhance the traditional sole proprietorship. It allows a single promoter to have full control over the company, limiting their liability to their contributions. The promoter serves as the sole shareholder and director, with a nominee appointed to step in if the director becomes incapacitated, though the nominee has no authority until needed.
//           </p>

//           {/* Key Features */}
//           <h2 style={{ color: "#001F3F", fontWeight: 600, marginBottom: "6px", fontFamily: "Times New Roman, Georgia, serif" }}>
//             Key Features
//           </h2>
//           <div style={{ width: "80px", height: "3px", background: "#22c55e", borderRadius: "2px" }}></div>
//           <ul>
//             <li>Requires only one person for incorporation.</li>
//             <li>Limited to one shareholder, with a nominee as a backup.</li>
//             <li>Liability is restricted to the shareholder’s contribution.</li>
//             <li>No employee stock options or equity funding allowed.</li>
//             <li>Mandatory conversion to a Private Limited Company if turnover exceeds Rs. 2 crores or paid-up capital exceeds Rs. 50 lakh.</li>
//           </ul>

//           {/* Advantages */}
//           <h2 style={{ color: "#001F3F", fontWeight: 600, marginBottom: "6px", fontFamily: "Times New Roman, Georgia, serif" }}>
//             Advantages
//           </h2>
//           <div style={{ width: "80px", height: "3px", background: "#22c55e", borderRadius: "2px" }}></div>
//           <ul>
//             <li>Simple setup with a single owner managing all decisions.</li>
//             <li>Eligible for benefits like low-interest loans for small-scale industries.</li>
//             <li>Limited liability encourages risk-taking without risking personal assets.</li>
//             <li>No requirement for a cash flow statement in financial reporting.</li>
//             <li>Enjoys legal recognition similar to a Private Limited Company, enhancing credibility with banks.</li>
//           </ul>

//           {/* Disadvantages */}
//           <h2 style={{ color: "#001F3F", fontWeight: 600, marginBottom: "6px", fontFamily: "Times New Roman, Georgia, serif" }}>
//             Disadvantages
//           </h2>
//           <div style={{ width: "80px", height: "3px", background: "#22c55e", borderRadius: "2px" }}></div>
//           <ul>
//             <li>Restricted to one member; no additional shareholders allowed.</li>
//             <li>Mandatory conversion to a Private Limited Company if financial thresholds are crossed.</li>
//             <li>Limited capital-raising capacity compared to larger entities.</li>
//             <li>Nominee dependency can complicate succession planning.</li>
//           </ul>

//           {/* Registration Process */}
//           <h2 style={{ color: "#001F3F", fontWeight: 600, marginBottom: "6px", fontFamily: "Times New Roman, Georgia, serif" }}>
//             Registration Process
//           </h2>
//           <div style={{ width: "80px", height: "3px", background: "#22c55e", borderRadius: "2px" }}></div>
//           <p>
//             Registering an OPC involves a structured process under the Companies Act. Here’s how it works:
//           </p>
//           <ol>
//             <li>Obtain a Digital Signature Certificate (DSC) using address proof, Aadhaar, PAN, photo, email, and phone number.</li>
//             <li>Apply for a Director Identification Number (DIN) via SPICe Form with name and address proof.</li>
//             <li>Submit a name approval application to the MCA, ensuring the name includes "OPC."</li>
//             <li>Prepare and submit documents: MoA, AoA, nominee consent (Form INC-3), proof of registered office, and director declarations.</li>
//             <li>File SPICe Form, SPICe-MOA, and SPICe-AOA with MCA for approval; PAN and TAN are generated automatically.</li>
//             <li>Receive the Certificate of Incorporation from the ROC, followed by bank account opening and business commencement filing.</li>
//           </ol>

//           {/* Conversion to Private Limited Company */}
//           <h2 style={{ color: "#001F3F", fontWeight: 600, marginBottom: "6px", fontFamily: "Times New Roman, Georgia, serif" }}>
//             Conversion to Private Limited Company
//           </h2>
//           <div style={{ width: "80px", height: "3px", background: "#22c55e", borderRadius: "2px" }}></div>
//           <p>
//             An OPC can be converted voluntarily after two years or mandatorily if paid-up capital exceeds Rs. 50 lakh or turnover exceeds Rs. 2 crores over three years. Conversion involves a special resolution, NOC from creditors, and filing with the ROC.
//           </p>

//           {/* Conclusion */}
//           <h2 style={{ color: "#001F3F", fontWeight: 600, marginBottom: "6px", fontFamily: "Times New Roman, Georgia, serif" }}>
//             Conclusion
//           </h2>
//           <div style={{ width: "80px", height: "3px", background: "#22c55e", borderRadius: "2px" }}></div>
//           <p>
//             The One Person Company structure is perfect for solo entrepreneurs seeking limited liability and legal recognition. However, understanding conversion triggers and compliance requirements is crucial for long-term success.
//           </p>

//         </div>
//       </div>

//       <Footer />
//     </div>
//   );
// };

// export default OnePersonCompany;












import React from "react";
import Footer from "./Footer";
import NavBar from "./NavBar";

const OnePersonCompany = () => {
  return (
    <div
      className="opc"
      style={{
        fontFamily: "Arial, sans-serif",
        backgroundColor: "#f5f5f5",
        margin: 0,
        padding: 0,
      }}
    >
      <NavBar />

      {/* Header */}
      <div
        className="page-header"
        style={{
          backgroundColor: "#00b050",
          color: "white",
          padding: "30px 20px",
          fontSize: "28px",
          fontWeight: "bold",
          textAlign: "center",
          marginTop: "65px",
        }}
      >
        One Person Company Registration
      </div>

      {/* Intro Paragraph */}
      <p
        className="intro"
        style={{
          maxWidth: "1200px",
          width: "95%",
          margin: "20px auto",
          padding: "20px",
        }}
      >
        One Person Company (OPC) Registration is an ideal choice for startups or
        individuals who wish to operate a business as a single owner. An OPC
        combines the benefits of a Private Limited Company while restricting the
        number of shareholders to one.
      </p>

      {/* Content Wrapper */}
      <div
        className="content-wrap"
        style={{
          maxWidth: "1200px",
          width: "95%",
          margin: "15px auto",
          padding: "20px",
        }}
      >
        <div
          className="card"
          style={{
            background: "white",
            padding: "25px",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
            lineHeight: "1.6",
            color: "#333",
          }}
        >
          {/* About OPC */}
          <div>
            <h2
              style={{
                color: "#001F3F",
                fontWeight: 600,
                marginBottom: "6px",
                fontFamily: "Times New Roman, Georgia, serif",
              }}
            >
              About One Person Company (OPC)
            </h2>
            <div
              className="underline"
              style={{
                width: "80px",
                height: "3px",
                background: "#22c55e",
                borderRadius: "2px",
              }}
            />
          </div>

          <p>
            A One Person Company (OPC) is a modern business structure introduced
            to enhance the traditional sole proprietorship. It allows a single
            promoter to have full control over the company, limiting their
            liability to their contributions. The promoter serves as the sole
            shareholder and director, with a nominee appointed to step in if the
            director becomes incapacitated, though the nominee has no authority
            until needed.
          </p>

          {/* Key Features */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: "6px",
              fontFamily: "Times New Roman, Georgia, serif",
            }}
          >
            Key Features
          </h2>
          <div
            className="underline"
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          />
          <ul>
            <li>Requires only one person for incorporation.</li>
            <li>Limited to one shareholder, with a nominee as a backup.</li>
            <li>Liability is restricted to the shareholder’s contribution.</li>
            <li>No employee stock options or equity funding allowed.</li>
            <li>
              Mandatory conversion to a Private Limited Company if turnover
              exceeds Rs. 2 crores or paid-up capital exceeds Rs. 50 lakh.
            </li>
          </ul>

          {/* Advantages */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: "6px",
              fontFamily: "Times New Roman, Georgia, serif",
            }}
          >
            Advantages
          </h2>
          <div
            className="underline"
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          />
          <ul>
            <li>Simple setup with a single owner managing all decisions.</li>
            <li>
              Eligible for benefits like low-interest loans for small-scale
              industries.
            </li>
            <li>
              Limited liability encourages risk-taking without risking personal
              assets.
            </li>
            <li>No requirement for a cash flow statement in financial reporting.</li>
            <li>
              Enjoys legal recognition similar to a Private Limited Company,
              enhancing credibility with banks.
            </li>
          </ul>

          {/* Disadvantages */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: "6px",
              fontFamily: "Times New Roman, Georgia, serif",
            }}
          >
            Disadvantages
          </h2>
          <div
            className="underline"
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          />
          <ul>
            <li>Restricted to one member; no additional shareholders allowed.</li>
            <li>
              Mandatory conversion to a Private Limited Company if financial
              thresholds are crossed.
            </li>
            <li>
              Limited capital-raising capacity compared to larger entities.
            </li>
            <li>Nominee dependency can complicate succession planning.</li>
          </ul>

          {/* Registration Process */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: "6px",
              fontFamily: "Times New Roman, Georgia, serif",
            }}
          >
            Registration Process
          </h2>
          <div
            className="underline"
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          />
          <p>
            Registering an OPC involves a structured process under the Companies
            Act. Here’s how it works:
          </p>
          <ol>
            <li>
              Obtain a Digital Signature Certificate (DSC) using address proof,
              Aadhaar, PAN, photo, email, and phone number.
            </li>
            <li>
              Apply for a Director Identification Number (DIN) via SPICe Form
              with name and address proof.
            </li>
            <li>
              Submit a name approval application to the MCA, ensuring the name
              includes "OPC."
            </li>
            <li>
              Prepare and submit documents: MoA, AoA, nominee consent (Form
              INC-3), proof of registered office, and director declarations.
            </li>
            <li>
              File SPICe Form, SPICe-MOA, and SPICe-AOA with MCA for approval;
              PAN and TAN are generated automatically.
            </li>
            <li>
              Receive the Certificate of Incorporation from the ROC, followed by
              bank account opening and business commencement filing.
            </li>
          </ol>

          {/* Conversion */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: "6px",
              fontFamily: "Times New Roman, Georgia, serif",
            }}
          >
            Conversion to Private Limited Company
          </h2>
          <div
            className="underline"
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          />
          <p>
            An OPC can be converted voluntarily after two years or mandatorily
            if paid-up capital exceeds Rs. 50 lakh or turnover exceeds Rs. 2
            crores over three years. Conversion involves a special resolution,
            NOC from creditors, and filing with the ROC.
          </p>

          {/* Conclusion */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: "6px",
              fontFamily: "Times New Roman, Georgia, serif",
            }}
          >
            Conclusion
          </h2>
          <div
            className="underline"
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          />
          <p>
            The One Person Company structure is perfect for solo entrepreneurs
            seeking limited liability and legal recognition. However,
            understanding conversion triggers and compliance requirements is
            crucial for long-term success.
          </p>
        </div>
      </div>

      <Footer />

      {/* Mobile fixes only – desktop remains untouched */}
      <style>
        {`
          .opc { overflow-x: hidden; }
          .opc * { box-sizing: border-box; word-break: break-word; hyphens: auto; }

          @media (max-width: 768px) {
            .page-header {
              font-size: 22px !important;
              padding: 18px !important;
            }
            .intro {
              max-width: 100% !important;
              width: 100% !important;
              margin: 12px auto !important;
              padding: 16px !important;
            }
            .content-wrap {
              max-width: 100% !important;
              width: 100% !important;
              margin: 12px auto !important;
              padding: 12px !important;
            }
            .card {
              padding: 16px !important;
              border-radius: 8px !important;
              box-shadow: 0 4px 8px rgba(0,0,0,0.08) !important;
            }
            .card h2 {
              font-size: 20px !important;
              margin-top: 12px !important;
              line-height: 1.3 !important;
            }
            .underline {
              width: 60px !important;
              height: 3px !important;
            }
            .card p, .card li {
              font-size: 14px !important;
              line-height: 1.7 !important;
            }
            .card ul, .card ol {
              padding-left: 18px !important;
              margin-left: 0 !important;
            }
            .card li { margin-bottom: 6px !important; }
          }

          @media (max-width: 480px) {
            .page-header {
              font-size: 20px !important;
              padding: 14px !important;
            }
            .card h2 { font-size: 18px !important; }
            .card p, .card li { font-size: 13px !important; }
            .card li { margin-bottom: 8px !important; }
          }
        `}
      </style>
    </div>
  );
};

export default OnePersonCompany;
